import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  HostListener,
} from '@angular/core';
import { BuildingManagementService } from 'src/app/building-managment/building-management.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Subscription } from 'rxjs';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { SiteManagerComponent } from 'src/app/site-management/site-manager/site-manager.component';
import { FloorManagementComponent } from 'src/app/floor-management/floor-management.component';
import {
  Activities,
  IActivityFilterCriteria,
} from 'src/app/shared-layout/Components/activity/activity.interface';
import { IAppState } from 'src/app/shared/state-management/state-interfaces';
import { NgRedux } from '@angular-redux/store';
import {
  updateBuildingActivities,
  clearBuildingActivities,
} from '../../shared/state-management/actions';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';
import { convertDateTimeFormat } from 'src/app/shared/utils/utility.service';
import { BuildingFilterActvityComponent } from 'src/app/shared-layout/Components/activity/building-filter-actvity/building-filter-actvity.component';
@Component({
  selector: 'app-building-details',
  templateUrl: './building-details.component.html',
  styleUrls: ['./building-details.component.scss'],
})
export class BuildingDetailsComponent implements OnInit, OnDestroy {
  isFetching: boolean = false;
  message = this.translate.instant('PLEASE_SELECT_A_BUILDING');
  subscription: Subscription | undefined;
  isEmpty = true;
  CONSTANTS = CONSTANTS;
  selectedBtn = CONSTANTS.DETAILS;
  sharedData: any;
  buildingActivityPageSize = 15;
  canLoad = false;
  buildingActivityCount: number = 0;
  serverBuildingActivityCount: number | undefined;
  buildingActivities: Activities = { events: [] };
  buildingId!: string;
  filterCriteria: IActivityFilterCriteria = {
    eventCode: [],
    dateTo: null,
    dateFrom: null,
    pagination: {
      cursor: [],
      size: 10,
    },
  };
  /** State passed to / returned from the building activity filter dialog. */
  filterActivity: any = {
    userType: null,
    dates: '',
    lockType: [],
    lockIds: [],
    entityType: CONSTANTS.BUILDING,
  };
  /** Number of active filters, shown as a badge on the filter button. */
  filterCount = 0;
  readonly LANG_CONST = LANG_CONST;
  @ViewChild(FloorManagementComponent) floorManagementComponentRefComp:
    | FloorManagementComponent
    | undefined;
  selectedbuildingId!: string;

  constructor(
    public buildingManagementService: BuildingManagementService,
    private sharedDataService: SharedDataService,
    private helperService: HelperService,
    private ngRedux: NgRedux<IAppState>,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {
    this.ngRedux
      .select('buildingActivities')
      .subscribe((buildingActivities: any) => {
        if (
          JSON.stringify(this.buildingActivities) !==
          JSON.stringify(buildingActivities)
        ) {
          this.buildingActivities = buildingActivities;
        }
      });
  }

  resetComponent(): void {
    this.isFetching = false;
    this.message = this.translate.instant('PLEASE_SELECT_A_BUILDING');
    this.CONSTANTS = CONSTANTS;
    this.selectedBtn = CONSTANTS.DETAILS;
    this.buildingActivityPageSize = 15;
    this.canLoad = false;
    this.buildingActivityCount = 0;
    this.buildingActivities = { events: [] };
    this.filterCriteria = {
      eventCode: [],
      dateTo: null,
      dateFrom: null,
      pagination: {
        cursor: [],
        size: 30,
      },
    };
    this.filterActivity = {
      userType: null,
      dates: '',
      lockType: [],
      lockIds: [],
      entityType: CONSTANTS.BUILDING,
    };
    this.filterCount = 0;
  }
  /**
   * @description: runs on when component is initialized. This method subscribes sharedDataService,
   *                and set the isEmpty flag false or true.
   * @input {none}
   * @output {void}
   */

  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.sharedDataService.currentData.subscribe((sharedData) => {
      this.sharedData = sharedData;
      const buildingId = this.sharedData?.selectedBuilding?.buildingId;

      if (
        this.sharedData.selectedBuilding.buildingName &&
        this.sharedData.selectedBuilding.buildingId
      ) {
        this.isEmpty = false;
        this.buildingId = this.sharedData.selectedBuilding.buildingId;
      } else {
        this.isEmpty = true;
      }

      if (
        this.sharedData.selectedBuilding.buildingId &&
        this.selectedbuildingId !== buildingId
      ) {
        this.selectedbuildingId = buildingId;
        this.buildingId = this.sharedData.selectedBuilding.buildingId;
        this.filterCriteria.siteId = this.sharedData?.selectedSite?.siteId;
        this.clearBuildingActivities();

        this.loadBuildingActivities();
      }
    });
  }
  clearBuildingActivities(): void {
    this.buildingActivities = { events: [] };
    this.resetComponent();
    this.ngRedux.dispatch(clearBuildingActivities());
  }
  loadBuildingActivities(): void {
    if (this.isFetching) return;
    this.isFetching = true;
    this.canLoad = true;

    this.buildingManagementService
      .getEventHistoryByBuilding(
        this.buildingId,
        this.filterCriteria,
        false,
        true
      )
      .subscribe(
        (res: any) => {
          if (res) {
            const newEvents = res.events;

            this.ngRedux.dispatch(updateBuildingActivities(newEvents));
            this.canLoad = res?.cursor && res?.cursor.length > 0;

            if (res.cursor) {
              this.filterCriteria.pagination.cursor = res.cursor;
              this.canLoad = false;
            }
          } else {
            this.canLoad = false;
          }
          this.isFetching = false;
        },
        (error: any) => {
          this.isFetching = false;
          this.canLoad = false;
        }
      );
  }

  /**
   * @description: btnToggle function accepts selection of toggle button and toggle the slection b/w Details & Activity
   * @input { string }
   * @param { select }
   * @output { void }
   */

  btnToggle(select: string) {
    this.selectedBtn = select;
  }

  /**
   * @description: opens the building activity filter dialog. Once applied it maps
   *               the selected filters into filterCriteria and reloads the building
   *               activity list from scratch (fresh results).
   * @input { none }
   * @output { void }
   */
  openBuildingActivityFilter(): void {
    const dialogInstance = this.helperService.openModalDialog(
      BuildingFilterActvityComponent,
      this.filterActivity,
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((filter: any) => {
      if (!filter) {
        return;
      }
      this.filterActivity = filter;

      const userCount = filter?.userType != null ? 1 : 0;
      const dateCount = filter?.dates ? 1 : 0;
      this.filterCount =
        (filter?.lockType?.length || 0) + userCount + dateCount;

      if (filter?.dates?.start && filter?.dates?.end) {
        this.filterCriteria.dateFrom = convertDateTimeFormat(
          filter.dates.start,
          "yyyy-MM-dd'T'HH:mm:ss"
        );
        this.filterCriteria.dateTo = convertDateTimeFormat(
          filter.dates.end,
          "yyyy-MM-dd'T'HH:mm:ss"
        );
      } else {
        this.filterCriteria.dateFrom = null;
        this.filterCriteria.dateTo = null;
      }

      this.filterCriteria.eventCode = filter?.eventCodes || [];
      this.filterCriteria.userType = filter?.userType ?? undefined;
      this.filterCriteria.pagination.cursor = [];
      this.filterCriteria.siteId = this.sharedData?.selectedSite?.siteId;

      // fresh results: clear the current list, then reload with the new filter
      this.ngRedux.dispatch(clearBuildingActivities());
      this.buildingActivities = { events: [] };
      this.canLoad = false;
      this.isFetching = false;
      this.loadBuildingActivities();
    });
  }

  /**
   * @description: openBuildingModal function se the editMode of Building to be true and open the modal box to enable dit building operation.
   * @input { none }
   * @output { void }
   */

  openBuildingModal(editBuilding: boolean, editFloor: boolean): void {
    this.sharedDataService.setEditMode({
      building: editBuilding,
      floor: editFloor,
    });
    const dialogInstance = this.helperService.openModalDialog(
      SiteManagerComponent,
      { enableBackOperation: false, defaultNavigation: CONSTANTS.BUILDING },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((result: boolean | undefined) => {
      if (result) {
        const siteId = this.sharedData?.selectedSite?.siteId;
        const buildingId = this.sharedData?.selectedBuilding?.buildingId;
        this.floorManagementComponentRefComp?.getFloorBySiteBuildingId(
          siteId,
          buildingId
        );
      }
    });
  }

  /**
   * @description this function responsible of fetch newly data and store update
   * @param ev event of scroll
   * @returns void
   */

  scrollDownEmitter(ev: any) {
    if (this.canLoad) {
      this.loadBuildingActivities();
    }
  }

  /**
   * @description: runs just before component unmount. Unsubscribes the sharedDataService service
   * @input {none}
   * @output {void}
   */

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
